<div class="d-flex justify-content-end">
  <div class="dropdown">
    <select class="form-select form-select-lg form-control" aria-label="Select your preferred language" id="selectedLanguage" name="selectedLanguage"
      [(ngModel)]="selectedLanguage" (change)="languageChanged($event)">
      <option value=null disabled selected>{{language.selectLanguage}}</option>
      <option *ngFor="let lang of languages" [value]="lang.code">{{lang.lang}}</option>
    </select>
  </div>
</div>